import { createPortal } from 'react-dom';

export function PrintPortal({ children }: { children: React.ReactNode }) {
  if (typeof document === 'undefined') return null; // SSR safety
  return createPortal(children, document.body);
}
